/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector, useValidatedUserPayload } from "../../app/hooks";
import {
  CognitoJwtPayload,
  selectUserAuthContext,
  updateUserAuthContext,
} from "../../features/console/consoleSlice";
import "./LandingPage.scss";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { Error } from "../../components/Error";
import { Auth } from "aws-amplify";
import { useDispatch } from "react-redux";
import {
  //useGetProductsQuery,
  //useLazyGetSubscriptionsQuery,
  useLazyUserCheckInQuery,
} from "../../services/gallus";
import { Product } from "../../services/types/gallus";
import { productsData } from "./ProductsHardcodedData";

interface LandingPageProps {}

/**
 * Landing page component. It connects to an API, gets the available products, and shows them if the user has access priviledges
 */
export const LandingPage = (props: LandingPageProps) => {
  const userAuthContext = useAppSelector(selectUserAuthContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userSession = useValidatedUserPayload();
  const [landingPageElements, setLandingPageElements] = useState<JSX.Element>();
  const [loading, setLoading] = useState<boolean>(true);
  /*   const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const [errorCode, setErrorCode] = useState<string>("");
  const [errorType, setErrorType] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>(""); */

  //Opted for a lazy query since the normal query would cache the result on log out
  //and log in with different user, causing query to not be relaunched.
  const [userCheckInQuery, userCheckInResult] = useLazyUserCheckInQuery();

  /**
   * Wrapper for generating a button's HTML code.
   * @param name  name of the product.
   * @param description description of the product.
   * @param url the URL the user will be moved to after clicking the button.
   * @param background URL of the background image. If blank, no image will be displayed.
   * @returns
   */
  const buttonWrapper = (product: Product, url: string | null): JSX.Element => {
    return (
      <div className="lp-pill" key={product.Name}>
        <div>
          <div className="lp-pill-name">{product.Name}</div>
          <div className="lp-pill-description">{product.Description}</div>
        </div>
        <div>
          {url && (
            <button
              type="button"
              className="btn btn-primary lp-pill-button"
              onClick={(e) => {
                navigate(url);
              }}
            >
              Go to product
            </button>
          )}
          {!url && (
            <button className="btn btn-primary lp-pill-button" disabled={true}>
              Please contact us
            </button>
          )}
        </div>
        <div
          className="lp-pill-background"
          style={{ backgroundImage: `url(${product.IconURL})` }}
        ></div>
      </div>
    );
  };

  useEffect(() => {
    if (
      userSession &&
      userSession.cognitoGroups &&
      userCheckInResult.isSuccess &&
      userCheckInResult.status === "fulfilled"
    ) {
      let accessible: boolean = false;
      let redirectUrl: string | null = "";
      let listOfButtonsTMP: JSX.Element[] = [];

      for (let product of productsData) {
        if (product.Enabled) {
          //we make sure the user can see the product
          if (
            product.Permissions.some(
              (groupsOfProduct) =>
                (userSession.cognitoGroups?.includes(groupsOfProduct) ||
                  userSession.cognitoGroups?.includes("Administrator")) ??
                false,
            )
          ) {
            redirectUrl = product.URLProduct;
            accessible = true;
            listOfButtonsTMP.push(buttonWrapper(product, redirectUrl));
          }
        }
      }

      if (listOfButtonsTMP.length === 1 && redirectUrl && accessible) {
        window.location.assign(redirectUrl);
      } else {
        if (listOfButtonsTMP.length === 0) {
          setLandingPageElements(
            <div style={{ textAlign: "center" }}>
              <div className="landing-page-no-product-title">
                There are no products associated with your account.
              </div>
              <div className="landing-page-no-product-text">
                Please email us at{" "}
                <a href="mailto:sales@gallusinsights.com">
                  sales@gallusinsights.com
                </a>
                for a free consultation.
              </div>
            </div>,
          );
        } else {
          setLandingPageElements(
            <div>
              <div className="landing-page-text">Please select a product:</div>
              <div
                className="landing-page-buttons"
                data-toggle="buttons"
                style={{ display: "flex" }}
              >
                {listOfButtonsTMP}
              </div>
            </div>,
          );
        }
      }
      setLoading(false);
    }
  }, [userSession, userCheckInResult]);

  useEffect(() => {
    const getSession = async () => {
      try {
        if (!userAuthContext) {
          const session = await Auth.currentSession();
          const sessionIdTokenPayload = session.getIdToken()
            .payload as CognitoJwtPayload;
          dispatch(
            updateUserAuthContext({
              username: sessionIdTokenPayload["cognito:username"],
              preferredUsername: sessionIdTokenPayload.preferred_username,
              idToken: session.getIdToken().getJwtToken(),
              accessToken: session.getAccessToken().getJwtToken(),
              refreshToken: session.getRefreshToken().getToken(),
            }),
          );
        }
      } catch (e) {
        navigate("/login");
      }
    };

    getSession();
    userCheckInQuery();
  }, []);

  return (
    <>
      <div className="landing-page-master">
        {loading && (
          <div className="loading-div">
            <FontAwesomeIcon
              icon={faSpinner}
              size="2x"
              spin={true}
              style={{ margin: "0 auto" }}
            />
          </div>
        )}
        {/* {!loading && errorFlag && (
          <Error code={errorCode} type={errorType} message={errorMessage} />
        )} */}
        {!loading && <div>{landingPageElements}</div>}
      </div>
    </>
  );
};
